class Utils {

  static staticPHIframe = '<p class="placeholder-glow placeholder-glow d-flex h-100 m-auto"><span class="placeholder col-8 m-auto"></span></p>';

  static staticPH = '<p class="placeholder-glow"><span class="placeholder col-8"></span></p>';

  static convertToUsNumberSystem(number) {
    const formatted = number.toLocaleString('en-US');
    return formatted;
  }

  static addSpaces(text) {
    return text.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  static getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name); // Returns null if not found
  }

  // Helper function to convert a single string to camelCase
  static toCamelCase(str) {
    return str
        .toLowerCase() // Make all characters lowercase
        .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
            index === 0 ? match.toLowerCase() : match.toUpperCase()
        )
        .replace(/\s+/g, ''); // Remove spaces
  }

  static jsonToFormData(json, parentKey = "", formData = new FormData()) {
    for (const key in json) {
      if (json.hasOwnProperty(key)) {
        const value = json[key];
        const formKey = parentKey ? `${parentKey}[${key}]` : key;

        if (value instanceof Object && !Array.isArray(value)) {
          // Recursively handle nested objects
          this.jsonToFormData(value, formKey, formData);
        } else if (Array.isArray(value)) {
          // Handle arrays
          value.forEach((item, index) => {
            formData.append(`${formKey}[${index}]`, item);
          });
        } else {
          // Append primitive values
          formData.append(formKey, value);
        }
      }
    }
    return formData;
  }

  static convertHtmlToText(html) {
    // Create a temporary DOM element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Remove script and style tags
    tempDiv.querySelectorAll('script, style').forEach(element => element.remove());

    // Replace <a> tags with 'text (href)' format
    tempDiv.querySelectorAll('a').forEach(anchor => {
      const text = anchor.textContent.trim();
      const href = anchor.getAttribute('href');
      const replacement = href ? `${text} (${href})` : text;
      anchor.replaceWith(replacement);
    });

    // Replace <br> tags with newlines
    tempDiv.querySelectorAll('br').forEach(br => {
      br.replaceWith('\n');
    });

    // Replace block-level elements with text + newline
    tempDiv.querySelectorAll('p, div, section, header, footer, article').forEach(block => {
      block.replaceWith(block.textContent + '\n');
    });

    // Final text processing
    return tempDiv.textContent
        .split('\n')
        .map(line => line.trim())
        .filter((line, index, lines) => line || (index > 0 && lines[index - 1]))
        .join('\n')
        .trim();
  }


  static generateEmail(baseName, domain) {
    // Generate a random number between 1000 and 9999
    const randomNumber = Math.floor(1000 + Math.random() * 9000);

    // Construct the email
    return `${baseName}+${randomNumber}@${domain}`;
  }

  // Static function
  static extractName(email) {
    // Extract the part before '+' or '@'
    const baseName = email.match(/^([^+@]+)/)?.[1] || "";

    // Split into first and last name (assumes "firstname.lastname" format or camelCase)
    const [firstName, lastName] = baseName.includes('.')
        ? baseName.split('.')
        : baseName.split(/(?=[A-Z])/);

    return {firstName, lastName};
  }

// Function to convert keys of a single object to camelCase
  static convertKeysToCamelCase(obj) {
    return Object.keys(obj).reduce((acc, key) => {
      const camelKey = this.toCamelCase(key);
      acc[camelKey] = obj[key];
      return acc;
    }, {});
  }

// Convert an array of JSON objects to camelCase keys
  static convertArrayKeysToCamelCase(arr) {
    return arr.map((obj) => this.convertKeysToCamelCase(obj));
  }

  static removeLeadParameter(url) {
    const app = PreBuilt;

    if (!app.isEmpty(url)) {
      // Original URL
      url = new URL(url);

      // Remove the 'lead_id' parameter
      url.searchParams.delete('lead_id');

      // Updated URL without the 'lead_id' parameter
      let updatedUrl = url.toString();

      return updatedUrl;
    }

    return null;
  }

  static jsonToQueryString(obj) {
    return Object.keys(obj)
        .map(key => {
          if (Array.isArray(obj[key])) {
            return obj[key]
                .map((item, index) => `${encodeURIComponent(key)}[${index}]=${encodeURIComponent(item)}`)
                .join('&');
          }
          return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
        })
        .join('&');
  }

  static addParamToURL(baseUrl, params) {
    // Check if the URL already contains a query string
    const hasQuery = baseUrl.includes("?");

    // Serialize the parameters
    const queryString = $.param(params);

    // Append the query string appropriately
    return baseUrl + (hasQuery ? "&" : "?") + queryString;
  }

  static capitalizeFirstLetter(str) {
    if (!str) return ''; // Handle empty strings
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  static appendQueryString(baseUrl, queryString) {
    // Check if the URL already contains a query string
    const hasQuery = baseUrl.includes("?");

    // Append the query string appropriately
    return baseUrl + (hasQuery ? "&" : "?") + queryString;
  }

  static arraysEqual(arr1, arr2) {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Check if all elements in the arrays are the same
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  static replaceEmptyValues(obj) {
    for (let key in obj) {
      if (obj[key] === null || obj[key] === '' || obj[key] === undefined) {
        obj[key] = 'N/A';
      } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        Utils.replaceEmptyValues(obj[key]); // Recursively handle nested objects
      }
    }
    return obj;
  }

  static validateMultiCheckbox($this) {
    // Get the parent form of the checkbox
    const form = $this.closest('form.needs-validation');
    const name = $this.attr('name');
    const $inputs = $(`:input[name="${name}"]`, form);
    let isChecked = false;

    $inputs.each(function () {
      if ($(this).is(':checked')) {
        // At least one checkbox is checked
        isChecked = true;
        return false; // Exit the loop early if a checkbox is checked
      }
    });

    if (isChecked) {
      // Remove is-invalid class from the checkbox and its parent form group
      $inputs.removeClass('is-invalid').addClass('is-valid');
      $inputs.each(function (index, input) {
        // Remove the 'required' attribute
        input.removeAttribute('required');
        input.setCustomValidity('');
      });
    } else {
      $inputs.each(function (index, input) {
        // Remove the 'required' attribute
        input.setAttribute('required', 'required');
      });
      // Remove is-invalid class from the checkbox and its parent form group
      $inputs.removeClass('is-valid')
    }

    // Check if the form is now valid after the change
    if (form[0].checkValidity()) {
      // If the form is valid, remove the was-validated class to reset validation styling
      form.removeClass('was-validated');
    }
  }

  static getTagClass() {
    const tagsClasses = ['secondary', 'danger', 'primary', 'info', 'success', 'warning']

    let randomIndex = Math.floor(Math.random() * tagsClasses.length);
    randomIndex = 0;
    // Get the random value from the array using the random index
    const randomValue = tagsClasses[randomIndex];
    return `${randomValue}`;
  }

  static getUniqueObjectsByKey(arrays, key) {
    const seen = new Set();

    return arrays.flat().filter(item => {
      const keyValue = item[key];
      if (!seen.has(keyValue)) {
        seen.add(keyValue);
        return true;
      }
      return false;
    });
  }

  static filterObjectByKey(obj, key, value) {
    return Object.keys(obj)
        .filter(function (k) {
          return obj[k][key] > value;
        })
        .reduce(function (res, k) {
          res[k] = obj[k];
          return res;
        }, {});
  }

  static getDifference(array1, array2, key) {
    // Create a set of keys from array2 for quick lookup
    const array2Keys = new Set(array2.map(obj => obj[key]));

    // Filter array1 to find objects that don't have a matching key in array2
    const difference = array1.filter(obj => !array2Keys.has(obj[key]));

    return difference;
  }

  static findClosestDateToToday(arr) {
    const today = new Date();
    let closest = arr[0];
    let closestDiff = Math.abs(new Date(arr[0].d) - today);

    arr.forEach(obj => {
      const date = new Date(obj.d);
      const diff = Math.abs(date - today);

      if (diff < closestDiff) {
        closestDiff = diff;
        closest = obj;
      }
    });

    return closest;
  }

  static filterByDateRange(arr, startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    return arr.filter(obj => {
      const date = new Date(obj.d);
      return date >= start && date <= end;
    }).sort((a, b) => new Date(a.d) - new Date(b.d));
  }

  static getDomain(url) {
    try {
      // Create a new URL object
      const parsedUrl = new URL(url);
      // Return the hostname which is the domain part of the URL
      return parsedUrl.hostname;
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  }

  static isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  static jsonEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  static isEqualIgnoringType(obj1, obj2) {
    const app = PreBuilt;

    if (app.isEmpty(obj1) && app.isEmpty(obj2)) {
      return true;
    }

    if (app.isEmpty(obj1) || app.isEmpty(obj2)) {
      return false;
    }

    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }

    for (let key in obj1) {
      if (!(key in obj2)) {
        return false;
      }

      const val1 = obj1[key];
      const val2 = obj2[key];

      const areBothObjects = typeof val1 === 'object' && typeof val2 === 'object';
      const areBothNull = val1 === null && val2 === null;

      if (areBothObjects && !areBothNull) {
        if (!Utils.isEqualIgnoringType(val1, val2)) {
          return false;
        }
      } else if (String(val1) !== String(val2)) {
        return false;
      }
    }
    return true;
  }

  static decodeEntities = (str) => {
    // this prevents any overhead from creating the object each time
    const element = document.createElement('div');

    function decodeHTMLEntities(str) {
      if (str && typeof str === 'string') {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = '';
      }

      return str;
    }

    return decodeHTMLEntities(str);
  }

  static groupBy = function (arr, key) {
    return arr.reduce((result, obj) => {
      const keyValue = obj[key];

      if (!result[keyValue]) {
        result[keyValue] = [];
      }

      result[keyValue].push(obj);

      return result;
    }, {});
  }


  static sanitize(value) {
    value = value.toString();
    return value.replace(/#/g, '');
  }

  static uniqueHashTags = (hashtags) => {
    hashtags = hashtags.split(',');

    hashtags = [...new Set(hashtags)];

    hashtags = hashtags.filter(element => element !== "" && element != null);

    hashtags = hashtags.map(hashtag => '#' + this.sanitize(hashtag));

    return hashtags;
  }

  static uniqueTags = (tags) => {
    if (!Array.isArray(tags)) {
      tags = tags.split(',');
    }

    tags = [...new Set(tags)];

    tags = tags.filter(element => element !== "" && element != null);

    tags = tags.map(tag => this.sanitize(tag));

    return tags;
  }

  static getTab(id) {
    let triggerEl = $(`.pg-header-wth-tab a[href="${id}"]`)
    if (!triggerEl.length) {
      triggerEl = $(`.sub-menu a[href="${id}"]`)
    }
    if (!triggerEl.length) {
      triggerEl = $(`.social-networks-profiles a[href="${id}"]`)
    }
    if (!triggerEl.length) {
      triggerEl = $(`.post-editor-container a[href="${id}"]`)
    }
    if (!triggerEl.length) {
      triggerEl = $(`.design-library-container a[href="${id}"]`)
    }
    return triggerEl;
  }

  static getTabContent(id) {
    let tab = null;
    const triggerEl = this.getTab(id);
    if (triggerEl.length) {
      tab = $(`${triggerEl.attr('href')}`)
    }
    return tab;
  }

  static showTab(id) {
    const triggerEl = this.getTab(id);

    if (triggerEl.length) {
      const tab = $(`${triggerEl.attr('href')}`)
      tab.show() // Select tab by
      triggerEl.show();
    }
  }

  static createAndShowTab(id) {
    const triggerEl = this.getTab(id);
    if (triggerEl.length) {
      const tab = new bootstrap.Tab(triggerEl);
      tab.show() // Select tab by name
    }
    return triggerEl;
  }

  static hideTabContent(id) {
    const triggerEl = $(id);
    if (triggerEl.length) {
      triggerEl.removeClass('active') // Select tab by
      triggerEl.removeClass('show') // Select tab by
    }
  }

  static showTabContent(tab) {
    tab.addClass('active show') // Select tab by
  }

  static hideTab(id) {
    const triggerEl = this.getTab(id);
    if (triggerEl.length) {
      const tab = $(`${triggerEl.attr('href')}`)
      triggerEl.hide();
    }
  }

  static tabExists(id) {
    const triggerEl = this.getTab(id);
    return triggerEl.length && triggerEl.is(":visible");
  }

  /**
   * Sets the value of a switch input and optionally triggers a change event. Additionally, it manages
   * the visibility of a collapsible element associated with the switch based on the switch's value.
   *
   * @param {jQuery} $switch - The jQuery object representing the switch input whose value is to be set.
   * @param {boolean} value - The value to set on the switch input (true for checked, false for unchecked).
   * @param {boolean} triggerChange - Flag indicating whether a change event should be triggered on the switch after setting its value.
   */
  static setSwitchVal($switch, value, triggerChange = false) {
    // Set the switch's checked property based on the provided value.
    $switch.prop('checked', value);

    // If triggerChange is true, trigger the 'change' event on the switch.
    if (triggerChange) {
      $switch.trigger('change');
    }

    // Retrieve the data-bs-target attribute from __this.switchCustomTime to identify the collapsible element.
    const collapseTarget = $switch.attr('data-bs-target');

    // If collapseTarget is defined, manage the visibility of the associated collapsible element.
    if (typeof collapseTarget !== 'undefined') {
      // Create a new instance of bootstrap.Collapse for the target element, or get the existing one.
      const collapse = bootstrap.Collapse.getOrCreateInstance(collapseTarget, {
        toggle: false // Initialize without toggling the current state.
      });

      // Show or hide the collapsible element based on the value parameter.
      if (value) {
        collapse.show();
      } else {
        collapse.hide();
      }
    }
  }

  static doesOptionExist($select, value) {
    return $select.find(`option[value="${value}"]`).length > 0;
  }

  static isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
  }

  static mergeDeep(target, source) {
    // Create a new object to avoid modifying the original objects
    const result = Object.assign({}, target);

    if (Utils.isObject(target) && Utils.isObject(source)) {
      Object.keys(source).forEach(key => {
        if (Utils.isObject(source[key])) {
          if (!(key in target)) {
            // If the key doesn't exist in the target, directly assign a clone of it
            result[key] = Object.assign({}, source[key]);
          } else {
            // Otherwise, recursively merge the objects
            result[key] = Utils.mergeDeep(target[key], source[key]);
          }
        } else if (Array.isArray(source[key])) {
          if (!(key in target)) {
            // If the key doesn't exist in the target, directly assign a clone of the array
            result[key] = source[key].slice();
          } else if (Array.isArray(target[key])) {
            // Concatenate arrays if both target and source are arrays
            result[key] = target[key].concat(source[key]);
          } else {
            // If the target is not an array, replace it with the array from source
            result[key] = source[key];
          }
        } else {
          // For all other types, directly assign the value from source to result
          result[key] = source[key];
        }
      });

      // Ensure all keys from the target are present in the result
      Object.keys(target).forEach(key => {
        if (!(key in source)) {
          result[key] = target[key];
        }
      });
    } else {
      // If not both objects, just return a shallow copy of source
      return Object.assign({}, source);
    }
    return result;
  }

  static getOrdinalSuffix(i) {
    let j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
      return i + "st";
    }
    if (j === 2 && k !== 12) {
      return i + "nd";
    }
    if (j === 3 && k !== 13) {
      return i + "rd";
    }
    return i + "th";
  }

  static getDaysOfMonth() {
    let days = {};
    for (let i = 1; i <= 31; i++) {
      days[i] = Utils.getOrdinalSuffix(i);
    }
    return days;
  }


  /**
   * Sets the value of a switch input and optionally triggers a change event. Additionally, it manages
   * the visibility of a collapsible element associated with the switch based on the switch's value.
   *
   * @param {jQuery} $switch - The jQuery object representing the switch input whose value is to be set.
   * @param {boolean} value - The value to set on the switch input (true for checked, false for unchecked).
   * @param {boolean} triggerChange - Flag indicating whether a change event should be triggered on the switch after setting its value.
   */
  setSwitchVal($switch, value, triggerChange = false) {
    // Set the switch's checked property based on the provided value.
    $switch.prop('checked', value);

    // If triggerChange is true, trigger the 'change' event on the switch.
    if (triggerChange) {
      $switch.trigger('change');
    }

    // Retrieve the data-bs-target attribute from __this.switchCustomTime to identify the collapsible element.
    const collapseTarget = $switch.attr('data-bs-target');

    // If collapseTarget is defined, manage the visibility of the associated collapsible element.
    if (typeof collapseTarget !== 'undefined') {
      // Create a new instance of bootstrap.Collapse for the target element, or get the existing one.
      const collapse = bootstrap.Collapse.getOrCreateInstance(collapseTarget, {
        toggle: false // Initialize without toggling the current state.
      });

      // Show or hide the collapsible element based on the value parameter.
      if (value) {
        collapse.show();
      } else {
        collapse.hide();
      }
    }
  }
}

class Paginator {
  constructor(pageSize = 10) {
    this.pageSize = pageSize; // Items per page
    this.currentPage = null; // Current page initialization
  }

  getPageNo() {
    return this.currentPage;
  }

  setData(data) {
    this.data = data;
    this.recordsCount = this.data.length;
  }

  setCurrentPage(currentPage) {
    this.currentPage = currentPage;
  }

  // Get the current slice of data for the page
  getCurrentPage() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.data.slice(startIndex, endIndex);
  }


  // Load the next page of data
  getNextPage() {
    this.currentPage++; // Increment page count
    return this.getCurrentPage(); // Return the next page of data
  }

  // Check if there is more data to load
  hasMoreData() {
    //console.log(this.currentPage, this.pageSize * (this.currentPage - 1), this.data.length);
    return (this.pageSize * (this.currentPage)) < this.recordsCount;
  }

  // Reset paginator to initial state
  reset() {
    this.currentPage = 1;
  }

  // Load data until a specific ID is not found
  loadDataUntilIdFound(targetId) {
    let accumulatedData = [];
    let targetIdStr = targetId.toString(); // Ensure comparison accounts for different types

    while (this.hasMoreData()) {
      const data = this.getCurrentPage();
      accumulatedData = accumulatedData.concat(data);

      // Check if the current page contains the target ID
      const itemFound = data.some(item => item.id.toString() === targetIdStr);
      this.setCurrentPage(this.currentPage + 1);

      if (itemFound) {
        // If the target ID is found, exit the loop
        break;
      }
    }

    return accumulatedData;
  }

  // Calculate the total number of pages
  getTotalPages() {
    return Math.ceil(this.recordsCount / this.pageSize);
  }

  setRecordsCount(count) {
    this.recordsCount = count;
  }
}

class ButtonsPaginator {
  render() {
    const app = PreBuilt;

    if (this.contentDiv.find('.paginator').length) {
      this.contentDiv.find('.paginator').remove();
    }

    const page = _.template(app.templates['global__paginator']);
    let pageData = {};

    const $page = $(page(pageData));
    $page.appendTo(this.contentDiv);
  }

  constructor(contentDiv, updateContentCallback) {
    this.currentPage = 1;
    this.contentDiv = contentDiv;
    this.updateContentCallback = updateContentCallback;

    this.render();
    // Get all pagination controls
    this.firstPageBtns = document.querySelectorAll('.firstPage');
    this.prevPageBtns = document.querySelectorAll('.prevPage');
    this.nextPageBtns = document.querySelectorAll('.nextPage');
    this.lastPageBtns = document.querySelectorAll('.lastPage');
    this.pageInputs = document.querySelectorAll('.pageInput');

    // Bind events for all buttons and inputs
    this.firstPageBtns.forEach(btn => btn.addEventListener('click', () => this.goToFirstPage()));
    this.prevPageBtns.forEach(btn => btn.addEventListener('click', () => this.goToPrevPage()));
    this.nextPageBtns.forEach(btn => btn.addEventListener('click', () => this.goToNextPage()));
    this.lastPageBtns.forEach(btn => btn.addEventListener('click', () => this.goToLastPage()));
    this.pageInputs.forEach(input => input.addEventListener('change', () => this.goToPage(input)));
  }

  setTotalPages(totalPages) {
    this.totalPages = totalPages;
    this.updatePageInputs();
  }

  async updateContent() {
    this.contentDiv.find('.paginator-info').text(`Loading content for page ${this.currentPage}...`);
    await this.updateContentCallback(this.currentPage);
    this.contentDiv.find('.paginator-info').text(``);
  }

  updatePageInputs() {
    this.pageInputs.forEach(input => input.value = `${this.currentPage} of ${this.totalPages}`);
  }

  async goToFirstPage() {
    this.currentPage = 1;
    await this.updateContent();
    this.updatePageInputs();
  }

  async goToPrevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      await this.updateContent();
      this.updatePageInputs();
    }
  }

  async goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      await this.updateContent();
      this.updatePageInputs();
    }
  }

  async goToLastPage() {
    this.currentPage = this.totalPages;
    await this.updateContent();
    this.updatePageInputs();
  }

  async goToPage(input) {
    let inputPage = parseInt(input.value);
    if (inputPage >= 1 && inputPage <= this.totalPages) {
      this.currentPage = inputPage;
      await this.updateContent();
      this.updatePageInputs();
    } else {
      this.updatePageInputs();
    }
  }
}


class PaginatedUrl {

  constructor(baseUrl, pageNo = 1, pageSize = 10) {
    this.baseUrl = baseUrl;
    this.pageNo = pageNo;
    this.pageSize = pageSize;
  }

  setPageCount(pages) {
    this.pageCount = pages;
  }

  hasMoreData() {
    return this.pageNo <= this.pageCount;
  }

  // Function to add parameters to the URL
  addParamsToUrl(baseUrl, params) {
    // Check if the URL already contains a query string
    const hasQuery = baseUrl.includes("?");

    // Serialize the parameters
    const queryString = $.param(params);

    // Append the query string appropriately
    return baseUrl + (hasQuery ? "&" : "?") + queryString;
  }

  getPageUrl(pageNo, params = {}) {
    params = {...params, ...{'page': pageNo, 'limitPerPage': this.pageSize}};
    return this.addParamsToUrl(this.baseUrl, params);
  }

  getCurrentPageUrl(moveCursor) {
    const page = this.pageNo;
    if (moveCursor) {
      this.moveCursorToNext();
    }
    return this.getPageUrl(page);
  }

  getNextPageUrl() {
    return this.getPageUrl(this.pageNo + 1);
  }

  getPreviousPageUrl() {
    if (this.pageNo > 1) {
      return this.getPageUrl(this.pageNo - 1);
    } else {
      return null; // No previous page
    }
  }

  getCurrentPage() {
    return this.pageNo;
  }

  setPage(pageNo) {
    this.pageNo = pageNo;
  }

  moveCursorToNext() {
    this.pageNo++;
    return this.pageNo;
  }
}

// Define EventManager class
class EventManager {
  constructor(namespace, selector, root = null) {
    this.namespace = namespace;
    this.selector = selector;
    this.root = root ? root : $(document);
  }

  addEventListener(eventType, callback) {
    const fullEventType = this.constructFullEventType(eventType);
    this.root.off(fullEventType, this.selector).on(fullEventType, this.selector, callback);
  }

  dispatchEventListener(eventType, $activeSelector) {
    const fullEventType = this.constructFullEventType(eventType);
    $activeSelector[0].dispatchEvent(new Event(eventType, {bubbles: false, cancelable: false}));
  }

  removeEventListener(eventType) {
    const fullEventType = this.constructFullEventType(eventType);
    this.root.off(fullEventType, this.selector);
  }

  constructFullEventType(eventType) {
    return `${eventType}.${this.namespace}`;
  }
}

class ProgressBar {
  messages = ["Loading...", "Still working on it...", "Just a bit more...", "Almost done..."];

  template = `
    <div class="progress-container">
      <div class="progress progress-bar-sm rounded-8 ">
        <div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div class="progress-text text-end pt-2">Initiated...</div>
    </div>
  `;

  constructor(container, messages = []) {
    this.app = PreBuilt;
    this.progressBarContainer = $(this.template);
    this.progressBarContainer.appendTo($(container));
    this.progressBarContainer = this.progressBarContainer;
    this.progressBar = this.progressBarContainer[0].querySelector('.progress-bar');
    this.progressText = this.progressBarContainer[0].querySelector('.progress-text');
    this.currentValue = 0;
    this.messageIndex = 0;

    if (!this.app.isEmpty(messages)) {
      this.messages = messages;
    }

    this.messagesCount = this.messages.length;
    this.timer = null;
  }

  start() {
    const interval = 1000, step = 1;
    this.stop();  // Stop any existing progress
    this.timer = setInterval(() => {
      if (this.currentValue >= 100) {
        this.complete();
      } else {
        this.currentValue += step;
        this.update(this.currentValue, step);
      }
    }, 100);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  update(value, step) {
    value = Math.min(100, Math.max(0, value));  // Clamp value between 0 and 100
    this.progressBar.style.width = `${value}%`;
    this.progressBar.setAttribute('aria-valuenow', value);
    // Calculate step size based on total messages, each step accounts for two indices
    const stepSize = Math.floor(100 / (this.messagesCount * 1.2));

    // Calculate the target value at the current message index (1-based)
    const targetValue = stepSize * (this.messageIndex + 1);

    if (value === targetValue) {
      if (!this.app.isEmpty(this.messages[this.messageIndex])) {
        this.progressText.innerHTML = this.messages[this.messageIndex++];
      }
    }
  }

  updateOneStep() {
    // Calculate step size based on total messages, each step accounts for two indices
    const stepSize = Math.ceil(100 / (this.messagesCount));
    let targetValue = stepSize * (this.messageIndex + 1);

    targetValue = Math.min(100, targetValue);  // Clamp value between 0 and 100

    this.progressBar.style.width = `${targetValue}%`;
    this.progressBar.setAttribute('aria-valuenow', targetValue);

    if (!this.app.isEmpty(this.messages[this.messageIndex])) {
      this.progressText.innerHTML = this.messages[this.messageIndex++];
    }
  }

  complete() {
    this.update(100);
    this.stop();
  }

  remove() {
    this.progressBarContainer.remove();
  }

  reset() {
    this.update(0);
    this.messageIndex = 0;
    this.currentValue = 0;
    this.stop();
  }
}

class Responsive {
  static suggestColumns(containerWidth, minCardWidth, maxCardWidth) {
    // Calculate the maximum possible number of columns with minimum card width
    let maxColumns = Math.floor(containerWidth / minCardWidth);

    // Calculate the minimum possible number of columns with maximum card width
    let minColumns = Math.ceil(containerWidth / maxCardWidth);

    let suggestedColumns = maxColumns;


    return suggestedColumns;
  }

  static getCalendarColumn($calculationContainer, $container, maxWidth = 400, minWidth = 320, maxColumns = 3) {
    const containerWidth = $calculationContainer.width();
    let grid = this.suggestColumns(containerWidth, minWidth, maxWidth);
    if (grid > maxColumns) grid = maxColumns;
    $container.removeClass('row-cols-1 row-cols-2 row-cols-3 row-cols-4 row-cols-5 row-cols-6 row-cols-7 row-cols-8');
    $container.addClass(`row-cols-${grid}`);

    if (!$calculationContainer.attr('data-resize-observer')) {
      $calculationContainer.attr('data-resize-observer', true);
      const observeResize = new ResizeObserver(entries => {
        Responsive.getCalendarColumn($calculationContainer, $container, maxWidth, minWidth, maxColumns);
      });
      observeResize.observe($calculationContainer[0]);
    }
  }

  static getCollectionsColumn($calculationContainer, $container) {
    this.getCalendarColumn($container.parent(), $container, 250, 200, 5)
  }

  static getImagesColumn($calculationContainer, $container) {
    this.getCalendarColumn($container.parent(), $container, 250, 180, 5)
  }


}

class DropdownUtility {
  constructor(selector) {
    this.$dropdown = $(selector);
    if (!this.$dropdown.length) {
      console.error('Dropdown element not found');
      return;
    }
  }

  populateDropdown(data, valueKey, textKey, defaultOption = 'Select an option') {
    if (!Array.isArray(data)) {
      console.error('Data must be an array');
      return;
    }

    // Clear existing options
    this.$dropdown.empty();

    // Add a default option
    this.$dropdown.append(`<option value="">${defaultOption}</option>`);

    // Populate dropdown with options
    data.forEach(item => {
      if (item[valueKey] && item[textKey]) {
        this.$dropdown.append(
            `<option value="${item[valueKey]}" >${item[textKey]}</option>`
        );
      }
    });
  }
}
